import { render, staticRenderFns } from "./MapaProveedores.vue?vue&type=template&id=8fba189c&"
import script from "./MapaProveedores.vue?vue&type=script&lang=js&"
export * from "./MapaProveedores.vue?vue&type=script&lang=js&"
import style0 from "./MapaProveedores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports